import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {_} from 'underscore';
import {BlockVO} from '../model/BlockVO';
import {TypeBlockLabel} from '../model/TypeBlock';
import {Legends} from '../model/Legends';
import {environment} from '../../environments/environment';
import * as moment from 'moment';
import {SessionService} from './SessionService';
import {UserService} from './UserService';
import {TimeZoneService} from './TimeZoneService';
import {Observable} from 'rxjs/Observable';
import {RoleService} from './RoleService';
import {
  DATE_D_M_Y_SLASH_FORMAT,
  DATE_DEFAULT_FORMAT,
  DATE_MOUNTH_DAY_FORMAT,
  DATE_TIME_AT_0_0_0,
  DATE_TIME_AT_23_59_59,
  DATE_TIME_AT_7_0_0,
  DATE_TIME_FORMAT, JUSTIFICATION_TIME_INSERT,
  MAURICE_TIME_LIMIT,
  MIN_DATE_TO_APPLY_NIGHT_SHIFT,
  NIGH_SHIFT_START_TIME,
  NIGHT_SHIFT_END_TIME,
  NIGHT_SHIFT_MIDI,
  NIGHT_SHIFT_MIDI_ALMOST,
  NIGHT_SHIFT_MIDNIGHT,
  NIGHT_SHIFT_MIDNIGHT_ALMOST,
  NORMAL_SHIFT_END_TIME,
  NORMAL_SHIFT_START_TIME
} from '../model/commons/DateConstants';
import {
  CASUALLEAVE,
  EXCEPTIONAL_HOLIDAY,
  PAID_HOLIDAY,
  RTTHOLIDAY,
  SENIORITYHOLIDAY,
  UNPAID_HOLIDAY
} from '../model/commons/HolidayConstants';
import {LoggerService} from './LoggerService';
import {isBlockDemiloFilter, isBlockOdigoFilter} from '../helpers/Dimelo';
import {race} from 'rxjs/observable/race';
import {timer} from 'rxjs/observable/timer';
import {
  DATE_DEBUT_DEMANDE_LABEL,
  DATE_DEBUT_FICHE_LABEL, DATE_DEMANDE_LABEL, DATE_FICHE_LABEL, DATE_FIN_DEMANDE_LABEL, DATE_FIN_FICHE_LABEL,
  PORTUGAL_CODE,
  TIMER_INDICATOR,
  TMP_MAX_WAIT_TIME_IN_MS
} from '../helpers/GlobalConstants';
import {configReopenFichePredicate} from './open-fiche.service';
import {TranslateService} from '@ngx-translate/core';
import {CroisementVO} from '../model/CroisementVO';
import {VerroVO} from '../model/VerroVO';
import {ResponseVerro} from '../model/ResponseVerro';
import {CommentFiche} from '../model/comment';
import {FeatureAccessService} from './feature-access.service';


@Injectable()
export class BlockService {
  static readonly SEARCH_VERRO_TL_URL = `?joursValidationMax=${environment.verroFiche.joursValidationMax}&limitJours=${environment.verroFiche.limitJours}&profondeurMin=${environment.verroFiche.profondeurMinOPS}&profondeurMax=${environment.verroFiche.profondeurMaxOPS}`;
  static readonly SEARCH_VERRO_OPS_URL = `?joursValidationMax=${environment.verroFiche.joursValidationMax}&limitJours=${environment.verroFiche.limitJours}&profondeurMin=${environment.verroFiche.profondeurMinBUM}&profondeurMax=${environment.verroFiche.profondeurMaxBUM}`;
  static readonly SEARCH_VERRO_BUM_URL = `?joursValidationMax=${environment.verroFiche.joursValidationMax}&limitJours=${environment.verroFiche.limitJours}&profondeurMin=${environment.verroFiche.profondeurMinDS}&profondeurMax=${environment.verroFiche.profondeurMaxDS}`;
  static readonly PLANNED = (e: any) => e.type == "PLANNED";
  MIN_BLOCK_LENGTH_FR = 60;
  static readonly PLANNED_AND_REALISE = (e: any) => e.source != 'SYSTEM';
  static readonly PLANNED_NOT_HOLIDAY = (e: any) => BlockService.PLANNED(e) && !BlockService.IN_HOLIDAYS(e);
  static readonly IS_MAURICE = (block) => block.user && block.user.username.startsWith('R');
  static readonly INCOHERENCE_AS_CONGE = d => ['CPN', 'CSS',  'MAT', 'PAT', 'CASUALLEAVE'].includes( d.justification);
  static readonly CONGE_INCOHERENCE = 'CONGE_INCOHERENCE';
  static readonly IS_DAYOFF = (e: any) => String(e.label).toUpperCase() == "OFF";
  static readonly IN_HOLIDAYS = (e: any) =>
    e.label == PAID_HOLIDAY
    || e.label == UNPAID_HOLIDAY
    || e.label == EXCEPTIONAL_HOLIDAY
    || e.label == SENIORITYHOLIDAY
    || e.label == RTTHOLIDAY
    || e.label == CASUALLEAVE
  ;

  user = { username: '', firstname: '', lastname: '', date: new Date(), _username: null };
  public block: BlockVO = { blocksTad: [], user: null, legend: null, dataset: [], temps_data: null, breaks: [], isNight: false, hasDupplicateHoursDueToNightShift: false, hasDupplicateHoursDueToDayShift: false, tmpBreaks: [] };
  public currentDate;
  public currentUser;
  public isDayOFF = false;
  public saveData: any = {};
  public displayReopenButton = false;
  public refreshData: any = {};
  isMidiToMidiDisplay = false;
  public _isDayOff = false;
  public reclamButtonEnabled = false;
  public TimezoneGMT = 0;
  public emptyData: any = { start: NORMAL_SHIFT_START_TIME, end: NORMAL_SHIFT_END_TIME };
  public endRealTime = null;
  public countryUser: string = null;
  endPaie: any;
  startPaie: any;
  nbMois: any;
  alreadyExists = false;
  existRequestUnlocking = false;
  public set_format_block: any;
  public isShowSeuil = false;
  constructor(private http: HttpClient,
    private translate: TranslateService,
    private session: SessionService,
    private userService: UserService,
    public tzService: TimeZoneService,
    private roleService: RoleService,
    private LOG: LoggerService) { }

  verro(dataVerro):Observable<ResponseVerro> {
    let { usernameCC, date, limitJours, joursValidationMax, userName, moreForHierarchy } = dataVerro;
    let searchVerro = null;

    if (this.roleService.isTL) {
      const VERRO_TL_URL = `?dateFiche=${date}&joursValidationMax=${joursValidationMax}&limitJours=${limitJours}&matriculeTL=${userName}&matriculeCC=${usernameCC}`;
      searchVerro = VERRO_TL_URL;
    }
    if (this.roleService.isOps) {
      const VERRO_OPS_URL = `?dateFiche=${date}&joursValidationMax=${joursValidationMax}&limitJours=${limitJours}&matriculeCC=${usernameCC}&moreForHierarchy=${moreForHierarchy}`;
      searchVerro = VERRO_OPS_URL;
    }
    if (this.roleService.isBUM) {
      const VERRO_BUM_URL = `?dateFiche=${date}&joursValidationMax=${joursValidationMax}&limitJours=${limitJours}&matriculeCC=${usernameCC}&moreForHierarchy=${moreForHierarchy+1}`;
      searchVerro = VERRO_BUM_URL;
    }
    date = moment(date).format(DATE_DEFAULT_FORMAT);

    return this.http.get<ResponseVerro>(`${environment.api.blocktemps}/verro${searchVerro}`);
  }
  getTimeZoneFromReferentiel(username, ville, date, callback) {
    //https://mscore.intelcia.com
    let combineGet = this.http.get(`${environment.api.mscore}city-time-zone/collaborators/${username}?date=${moment(date).format(DATE_D_M_Y_SLASH_FORMAT)}`);

    return combineGet.subscribe((tz: any) => {
      if(!tz.hasOwnProperty("timeZone")) { tz["timeZone"] = environment.tzDefault; }
      this.tzService.tz = parseInt((tz.data ? tz.data : tz.timeZone));
      this.tzService.payload = tz;
    }, error => {
      this.tzService.getTimeZoneByUser(true)
      callback()
    }, () => {
      callback()
    });
    //   return this.http.get(`${environment.api.mscore}city-time-zone/${ville}/${date}`);
  }
  putBlock(data: any, c?) {
    this.http.post(environment.api.blocktemps + '/block/divblocks', data)
      .subscribe((d: any) => {
        if (c !== undefined) {
          c(data);
        }
      },
        error => {
          this.session.redirectBadRequest(error);
        }
      );
  }
  getPlanned(matricules, date) {
    let headers = new HttpHeaders();
    headers = headers.append('content-type', 'application/x-www-form-urlencoded');
    // hardcode api to old api replace [environment.api.oldBlocktemps to https://myshift2.intelcia.com/api]
    return this.http.post(`${environment.api.myshiftUrl}/support?date=${date}&matricules=${matricules}`, {}, { headers })
  }
  putBreaks(data: any, c?) {
    this.http.post(environment.api.blocktemps + '/break/overflow', data)
      .subscribe((d: any) => {
        if (c !== undefined) {
          c(data);
        }
      },
        error => {
          this.session.redirectBadRequest(error);
        }
      );
  }

  reopenBlockProcess(configs,role,countryCode){
    this.displayReopenButton = configs.filter(c=> this.configReopenFichePredicateV2(c,role,countryCode)).length > 0;
    configs.forEach(config=> config.dateFiche = moment(config.dateFiche).format(DATE_DEFAULT_FORMAT));
    if(this.displayReopenButton){
      this.startPaie = configs.find(config => config.startPaie || config.startPaie == 0).startPaie;
      this.endPaie = configs.find(config => config.endPaie || config.endPaie == 0).endPaie;
      this.nbMois = configs.find(config => config.mois || config.mois == 0).mois;
      const alreadyExistsConfig = configs.filter(config =>{
        return config.alreadyExists &&  moment(this.currentDate).isSame(moment(config.dateFiche))
      }).find(config => config.alreadyExists);
      const alreadyExistsConfigUnlocking = configs.filter(config =>{
        return config.existRequestUnlocking &&  moment(this.currentDate).isSame(moment(config.dateFiche))
      }).find(config => config.existRequestUnlocking);
      this.alreadyExists = alreadyExistsConfig && alreadyExistsConfig.alreadyExists;
      this.existRequestUnlocking = alreadyExistsConfigUnlocking && alreadyExistsConfigUnlocking.existRequestUnlocking;
    }
  }


  public configReopenFichePredicateV2(config,role,countryCode){
    return (config.countryCode == PORTUGAL_CODE || config.requestOpening) ||
      (FeatureAccessService.hasAccess('REOPEN_FICHE_PERIOD',countryCode.toUpperCase()))
  }
  getParamValidation(c?) {
    this.http.get(environment.api.blocktemps + '/block/paramValidation').subscribe(item => c(item));
  }
  getBlockByUser(user) {
    return this.saveData[user].data;
  }

  getThreeDaysBlocksAndBreaks(username, date){
    let api_j_minus = environment.api.blocktemps + '/block/details/?username=' + username + '&date=' + moment(date).subtract(1, 'days').format(DATE_DEFAULT_FORMAT)
    let api_j = environment.api.blocktemps + '/block/details/?username=' + username + '&date=' + date
    let api_j_plus = environment.api.blocktemps + '/block/details/?username=' + username + '&date=' + moment(date).add(1, 'days').format(DATE_DEFAULT_FORMAT)

    return Observable.combineLatest([
      this.http.get(api_j_minus),
      this.http.get(api_j),
      this.http.get(api_j_plus)
    ]);
  }

  load(hasAvailable, username: string, date: string, callback?, breaks?, blocksTad?) {
    this.block.blocksTad = blocksTad;
    return new Promise((resolve, reject) => {
      this._isDayOff = false;
      this.isDayOFF = false;
      let data: any = [];
      const that = this;
      this.currentDate = date;

      this.saveData[username] =
        {
          date: moment(date, DATE_DEFAULT_FORMAT).toDate(),
          data: [],
          breaks: []
        };

      const params = new HttpParams({
        fromString: `username=${username}&date=${date}`
      });
      //      let api  = environment.api.blocktemps + '/block/timezoned?username=' + username + '&date=' + date + '&timeDfUtc='
      //      api += (username[0].toLowerCase() == 'r' ?  '4' : '0')
      this.user._username = username
      this.user.username = username
      const uri3 = environment.api.blocktemps +
        `/block/timezoned?username=${username}` +
        `&date=${moment(date).subtract(1, 'days').format(DATE_DEFAULT_FORMAT)}` +
        `&heureDebut=${moment(date).subtract(1, 'days').format(DATE_DEFAULT_FORMAT)}T00:00:00` +
        `&heureFin=${moment(date).add(1, 'days').format(DATE_DEFAULT_FORMAT)}T23:59:59`

      let isOne = location.href.split('/')
      let useOne = (isOne.lastIndexOf('one') > -1);
      let combineBlock;
      if (useOne) {
        combineBlock = this.http.get(uri3);
      } else {
        combineBlock = this.getThreeDaysBlocksAndBreaks(username, date);
      }

      // check has available blocks
      /*.subscribe(*/
      (hasAvailable ?  combineBlock : Observable.of([{
        blockVOS: [],
        breakVOS: [],
        config: {startPaie: 0, endPaie: 0, mois: 0, dateFiche: null, alreadyExists: false, existRequestUnlocking: false}
      }])) .subscribe((dataResponse: any) => {
        const blockVOS = dataResponse && dataResponse.map(b => b.blockVOS);
          const countryCode = this.userService.getUserCountry();
          const {authorities} = JSON.parse(localStorage.getItem(environment.oauth.remoteUser));
          let role = authorities.filter(e => e.clientId == 'myshift2').map(e => e.authority)
          let configs = dataResponse && dataResponse.map((b: any) => {
          return b.blockVOS[0] ? {...b.config, date: moment(b.blockVOS[0].start).format(DATE_DEFAULT_FORMAT)} : b.config;
        });
        blockVOS.forEach((d, i) => {
          data = data.concat(d)
        })
        // remove duplicate to unique block PS: IN CASE 3 API DETAILS RETURN SAME BLOCK
        data = _.unique(data, 'id');
          // extract country user from blocks
          if(data.length) {
            const [block] = data;
            if(block) {
              const {user} = block;
              const {country} = user || {country: null}
              this.countryUser = country;
            }
          }
          this.block.tmpBreaks = dataResponse && dataResponse.flatMap(b => b.breakVOS);
          this.reopenBlockProcess(configs,role,countryCode);
      },
        (err) => {
          this.session.redirectBadRequest(err);
          callback(that.formatBlock(username, date, data, breaks));
        },
        () => {
          let clone = this.cloneBlockList(data);
          const dateTimeNow = moment(this.getDateRealTime(true)).format(DATE_TIME_FORMAT);
          this.isMidiToMidiDisplay = this.night_shift_midi_to_midi_display_test(clone, date);
          const isReatTimeDate = moment(date).format(DATE_DEFAULT_FORMAT) == moment(Date.now()).format(DATE_DEFAULT_FORMAT);
          this.block.isNight = this.checkNightShift(clone.filter(BlockService.PLANNED_NOT_HOLIDAY), NIGH_SHIFT_START_TIME, NIGHT_SHIFT_MIDNIGHT_ALMOST, { fn: 'add', interval: 0 }).check
            && this.checkNightShift(clone.filter(BlockService.PLANNED_NOT_HOLIDAY), NIGHT_SHIFT_MIDNIGHT, NIGHT_SHIFT_END_TIME, { fn: 'add', interval: 1 }, true).check
          this.isMidiToMidiDisplay ? this.LOG.info(`${date} has Midi To Midi Display.`) : '';
          this.block.isNight ? this.LOG.info(`${date} has Night Shift Display .`) : '';
          const { _dayoffStartInterval, _dayoffEndInterval } = this.getIntervalOfCountry(date);
          const dayOffFilter = block => BlockService.PLANNED(block) && (moment(block.start).isBetween(moment(_dayoffStartInterval), moment(_dayoffEndInterval)) || moment(block.end).isBetween(moment(_dayoffStartInterval), moment(_dayoffEndInterval)));
          let filterClone = [...clone.filter(b => dayOffFilter(Object.assign({}, b)))];
          if(isReatTimeDate){
            clone = [...this.gmtToLocalData(clone)];
            this.LOG.info(`Real Time Block Is Opened For User ${username}.`);
            let realTimeBlocks = data.filter(ts => moment(ts.start).format(DATE_DEFAULT_FORMAT) == moment(Date.now()).format(DATE_DEFAULT_FORMAT)).slice();
            let realTimeBlocksReduit = data.filter(ts =>  ts.source != 'SYSTEM' && moment(ts.start).format(DATE_DEFAULT_FORMAT) == moment(Date.now()).format(DATE_DEFAULT_FORMAT)).slice();
            const nonPlannedAfterDateTimeNow = d => d.type != 'PLANNED' && ((d.end && moment(moment(d.end).format(DATE_TIME_FORMAT)).isAfter(dateTimeNow)) || !d.end);
            const endDateAfterDateTimeNow = d => !d.end || (d.end && moment(moment(d.end).format(DATE_TIME_FORMAT)).isAfter(dateTimeNow));
            // subscribe to results
            this.getRealTimeBlocks(realTimeBlocksReduit).subscribe((res: any) =>{
              res.blocks = res.blocks
                .slice()
                .filter(ts => moment(moment(ts.start).format(DATE_TIME_FORMAT)).isBefore(moment(dateTimeNow).format(DATE_TIME_FORMAT)))
                .map(d => { if(endDateAfterDateTimeNow(d)) d.end = dateTimeNow; return Object.assign({}, d); });
              data = realTimeBlocks.map(d => { if(nonPlannedAfterDateTimeNow(d)) d.end = dateTimeNow;  return Object.assign({}, d); });
              data = [...data, ...res.blocks];
              callback(that.formatBlock(username, date, data, breaks));
            });
          }else {
            if (filterClone.length == 0) {
              this.DayOff(username, date, (dayOff, MP, period) => {
                this.LOG.info(`${date} is a Day OFF.`);
                if (dayOff) {
                  callback(that.formatBlock(username, date, [...data], breaks, true, false));
                } else if (MP) {
                  callback(that.formatBlock(username, date, [...data], breaks, false, true, period));
                } else {
                  callback(that.formatBlock(username, date, [...data], breaks));
                }
              }, () => callback(that.formatBlock(username, date, [...data], breaks)));
            } else {
              const hasBlockDayOff = data.filter(e => (String(e.label).toUpperCase() == "OFF")).length > 0;
              callback(that.formatBlock(username, date, [...data], breaks, hasBlockDayOff));
            }
          }

        }
      );
    });
  }

  loadByData(blocks, username: string, date: string, callback?, breaks?) {
    const that = this;
    let data: any = [];
    this.saveData[username] = {
      date: moment(date, DATE_DEFAULT_FORMAT).toDate(),
      data: [],
      breaks: []
    };
    Observable.of([blocks]).subscribe((dataResponse: any) => {
      const blockVOS = dataResponse && dataResponse.map(b => b.blockVOS);
      const configs = dataResponse && dataResponse.map((b: any) => {
        return b.blockVOS[0] ? {...b.config, date: moment(b.blockVOS[0].start).format(DATE_DEFAULT_FORMAT)} : b.config;
      });
      blockVOS.forEach((d, i) => {
        data = data.concat(d)
      })
      this.block.tmpBreaks = dataResponse && dataResponse.flatMap(b => b.breakVOS);
      this.InitBlock(data, date, username, callback, that, breaks)
    })
  }

  private InitBlock(data: any, date: string, username: string, callback, that, breaks) {
    let clone = this.cloneBlockList(data);
    const dateTimeNow = moment(this.getDateRealTime(true)).format(DATE_TIME_FORMAT);
    this.isMidiToMidiDisplay = this.night_shift_midi_to_midi_display_test(clone, date);
    const isReatTimeDate = moment(date).format(DATE_DEFAULT_FORMAT) == moment(Date.now()).format(DATE_DEFAULT_FORMAT);
    this.block.isNight = this.checkNightShift(       clone.filter(BlockService.PLANNED_NOT_HOLIDAY),
        NIGH_SHIFT_START_TIME,
        NIGHT_SHIFT_MIDNIGHT_ALMOST, {
          fn: 'add',
          interval: 1
        }).check
      && this.checkNightShift(
        clone.filter(BlockService.PLANNED_NOT_HOLIDAY),
        NIGHT_SHIFT_MIDNIGHT,
        NIGHT_SHIFT_END_TIME, {
          fn: 'add',
          interval: 1
        }, true).check
    console.log("isNight - 244 :", JSON.stringify(this.block.isNight))

    this.isMidiToMidiDisplay ? this.LOG.info(`${date} has Midi To Midi Display.`) : '';
    this.block.isNight ? this.LOG.info(`${date} has Night Shift Display .`) : '';
    const {_dayoffStartInterval, _dayoffEndInterval} = this.getIntervalOfCountry(date);
    const dayOffFilter = block => BlockService.PLANNED(block) && (moment(block.start).isBetween(moment(_dayoffStartInterval), moment(_dayoffEndInterval)) || moment(block.end).isBetween(moment(_dayoffStartInterval), moment(_dayoffEndInterval)));
    let filterClone = [...clone.filter(b => dayOffFilter(Object.assign({}, b)))];
    if (isReatTimeDate) {
      clone = [...this.gmtToLocalData(clone)];
      this.LOG.info(`Real Time Block Is Opened For User ${username}.`);
      let realTimeBlocks = data.filter(ts => moment(ts.start).format(DATE_DEFAULT_FORMAT) == moment(Date.now()).format(DATE_DEFAULT_FORMAT)).slice();
      let realTimeBlocksReduit = data.filter(ts => ts.source != 'SYSTEM' && moment(ts.start).format(DATE_DEFAULT_FORMAT) == moment(Date.now()).format(DATE_DEFAULT_FORMAT)).slice();
      const nonPlannedAfterDateTimeNow = d => d.type != 'PLANNED' && ((d.end && moment(moment(d.end).format(DATE_TIME_FORMAT)).isAfter(dateTimeNow)) || !d.end);
      const endDateAfterDateTimeNow = d => !d.end || (d.end && moment(moment(d.end).format(DATE_TIME_FORMAT)).isAfter(dateTimeNow));
      // subscribe to results
      this.getRealTimeBlocks(realTimeBlocksReduit).subscribe((res: any) => {
        res.blocks = res.blocks
          .slice()
          .filter(ts => moment(moment(ts.start).format(DATE_TIME_FORMAT)).isBefore(moment(dateTimeNow).format(DATE_TIME_FORMAT)))
          .map(d => {
            if (endDateAfterDateTimeNow(d)) d.end = dateTimeNow;
            return Object.assign({}, d);
          });
        data = realTimeBlocks.map(d => {
          if (nonPlannedAfterDateTimeNow(d)) d.end = dateTimeNow;
          return Object.assign({}, d);
        });
        data = [...data, ...res.blocks];
        callback(that.formatBlock(username, date, data, breaks));
      });
    } else {
      const isEmptyInCurrentDate = filterClone.filter((e: any) => {
        return moment(e.start).format(DATE_DEFAULT_FORMAT) == date ||
          moment(e.end).format(DATE_DEFAULT_FORMAT) == date
      }).length == 0;
      if (isEmptyInCurrentDate || filterClone.length == 0) {
        this.DayOff(username, date, (dayOff, MP, period) => {
          this.LOG.info(`${date} is a Day OFF.`);
          if (dayOff) {
            callback(that.formatBlock(username, date, [...data, ...filterClone], breaks, true, false));
          } else if (MP) {
            callback(that.formatBlock(username, date, [...data, ...filterClone], breaks, false, true, period));
          } else {
            callback(that.formatBlock(username, date, [...data, ...filterClone], breaks));
          }
        }, () => callback(that.formatBlock(username, date, [...data, ...filterClone], breaks)));
      } else {
        callback(that.formatBlock(username, date, [...data, ...filterClone], breaks));
      }
    }

  }

  saveFile(guideType:string){
    this.downloadFile(guideType).subscribe(blob => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = guideType;
      link.click();
    });
  }

  cloneBlockList(blocks: Array<BlockVO>){
    return [...blocks.map(b => Object.assign({}, b))];
  }

  gmtToLocalData(obj){
    return obj.slice().map((d, i) => {
      d.start = this.tzService.GmtToLocale(d.start);
      d.end = this.tzService.GmtToLocale(d.end);
      d['tz'] = this.tzService.tz
      return {...d};
    });
  }
  // ToLocaltoGMTData(data){
  //   return data.slice().map((d, i) => {
  //     d.start = this.tzService.LocaleToGmt(d.start);
  //     d.end = this.tzService.LocaleToGmt(d.end);
  //     // d['tz'] = this.tzService.tz
  //     return d;
  //   });
  // }
  public PrepareJSON(data: any, username: string, date: any, breaks?) {
    // clean block end > start
    for (let i = 0; i < data.length; i++) {
      // remove is start equal end
      if (moment(data[i].start).isAfter(data[i].end)) {
        data.splice(i, 1);
      }
    }
    // sort data with start
    data = _.sortBy(data, 'start');
    if (data.length > 0) {
      this.emptyData.start = moment(data[0].start).format(DATE_TIME_FORMAT)
      this.emptyData.end = moment(data[data.length - 1].end).format(DATE_TIME_FORMAT)
    }
    // add key name block
    _.each(data, (d, i) => {
      switch (d.tag.toLowerCase()) {
        case 'planned': data[i]['name'] = d.tag.toUpperCase(); break;
        case 'fulfilled_system': data[i]['name'] = d.tag.toUpperCase(); break;
        case 'fulfilled': data[i]['name'] = 'FULFILLED_INCOHERENCE'; break;
        case 'incoherence': data[i]['name'] = 'FULFILLED_INCOHERENCE'; break;
      }
      // add end is null
      this.setEndOfBlock(d, data, i);
      // add legend (label + status + tag + activity)
      data[i]['legend'] = (
        (d.activityType.toLowerCase() === 'unknown') ? d.activityType : ((d.tag.toLowerCase() === 'planned') ? // if
          d.label + '_' + d.activityType : // else
          d.tag + '_' + d.blockStatus + '_' + d.activityType +
          ((d.validatedBy === null || d.validatedBy === undefined) ? '' : '_byuser'))
      ).toUpperCase();

      if(BlockService.INCOHERENCE_AS_CONGE(d)){
        data[i]['legend'] = BlockService.CONGE_INCOHERENCE;
      }
      // get info user
      if (this.user.firstname === '' || this.user.username !== username) {
        this.user = {
          username: d.user.username,
          firstname: d.user.fullNameWithMatricule,
          lastname: '',
          date: new Date(date),
          _username: username
        };
      }

    });
    for (let i = 0; i < data.length; i++) {
      for (let e = 0; e < data.length; e++) {
        if (data[i].start === data[e].start &&
          data[e].activityType.toLowerCase() === 'unknown' && data[e].name === 'FULFILLED_INCOHERENCE') {
          data.splice(e, 1);
        }
      }
    }
    const {_dayoffStartInterval, _dayoffEndInterval} = this.getIntervalOfCountry();
    const breakFilter = br => (br.start && moment(this.tzService.GmtToLocale(br.start)).isBetween(_dayoffStartInterval, _dayoffEndInterval)) || (br.end && moment(this.tzService.GmtToLocale(br.end)).isBetween(_dayoffStartInterval, _dayoffEndInterval));
    const isDimelo = data && [...data].some(isBlockDemiloFilter);
    const isOdigo = data && [...data].some(isBlockOdigoFilter);
    const isMaurice = username =>  username.startsWith('R');
    const breakMapper = br => {
      if(moment(this.tzService.GmtToLocale(br.start)).isBefore(_dayoffStartInterval)) br.start = this.tzService.LocaleToGmt(_dayoffStartInterval);
      if(!br.end ||(br.end &&  moment(this.tzService.GmtToLocale(br.end)).isAfter(_dayoffEndInterval))) br.end = this.tzService.LocaleToGmt(_dayoffEndInterval);
      br.tag = 'FULLFILLED';
      br.legend = 'FULLFILLED_PAUSE';
      br.name = 'FULFILLED_SYSTEM'
      return {...br};
    }
    const formattedTmpBreaks = [...this.block.tmpBreaks]
    .filter(breakFilter)
    .map(breakMapper);

    //create tad in hours block
    let filteredValidateBlock = data.find(item => (item.validatedBy && item.validated));
    const formattedBlocksTad: any[] = [...this.block.blocksTad].map((br) => {
      br['start']= br.date + ' ' + br.startTime;
      br['end']= br.date + ' '+ br.endTime;
      br['id']= -1;
      if(moment(this.tzService.GmtToLocale(br.start)).isBefore(_dayoffStartInterval)) br.start = this.tzService.LocaleToGmt(_dayoffStartInterval);
      if(!br.end ||(br.end &&  moment(this.tzService.GmtToLocale(br.end)).isAfter(_dayoffEndInterval))) br.end = this.tzService.LocaleToGmt(_dayoffEndInterval);
      br.tag = 'FULLFILLED';
      br.legend = 'FULFILLED_VALIDATED_INSERVICE_TAD';
      br.name = 'FULFILLED_INCOHERENCE';
      br.validatedBy = filteredValidateBlock ? filteredValidateBlock.validatedBy : null;
      br.validated = filteredValidateBlock ? filteredValidateBlock.validated : null;
      br.source = 'SYSTEM';
      return {...br};
    })
    return [...formattedBlocksTad, ...data, ...formattedTmpBreaks];
  }
  private getDateRealTime(flag?:boolean) {
    var req = new XMLHttpRequest();
    req.open('GET', top.location.protocol + '//' + top.location.host, false);
    req.send(null);
    this.endRealTime = moment(req.getResponseHeader('date')).subtract(this.tzService.tz, 'hours')
    if(flag){
      return moment(new Date(req.getResponseHeader('date')).toISOString(), DATE_TIME_FORMAT).format(DATE_TIME_FORMAT);;
    }
  }
  private setEndOfBlock(d, data: any, i) {
    if (Object.keys(d).indexOf('end') === -1) {
      const end = moment(new Date()).subtract(this.tzService.tz, 'hours').format(DATE_TIME_FORMAT);
      const startDay = moment(d.start).format(DATE_DEFAULT_FORMAT);
      const preffixEnd = (startDay == moment(this.currentDate).format(DATE_DEFAULT_FORMAT) ? d.start : this.currentDate);
      const endDay = moment(preffixEnd).format(DATE_DEFAULT_FORMAT) + NIGHT_SHIFT_MIDNIGHT_ALMOST;
      // console.error('preffixEnd', preffixEnd, d)
      if (moment(end).isBefore(endDay)) {
        // console.log('SET END DATE BLOCK', this.getDateRealTime(true));
        data[i]['end'] = this.getDateRealTime(true);
      } else {
        data[i]['end'] = moment(endDay).subtract(this.tzService.tz, 'hours').format(DATE_TIME_FORMAT);
      }
      /*console.log(data[i]['end']);*/
      return data;
    }
  }

  validationVerroRequest() {
    const dateTime = moment().format(DATE_TIME_FORMAT);
    if (this.roleService.isOps) return this.http.get(`${environment.api.blocktemps}/verro/details/${BlockService.SEARCH_VERRO_TL_URL}&ts=${dateTime}`);
    if (this.roleService.isBUM) return this.http.get(`${environment.api.blocktemps}/verro/details/${BlockService.SEARCH_VERRO_OPS_URL}&ts=${dateTime}`);
    if (this.roleService.isDS) return this.http.get(`${environment.api.blocktemps}/verro/details/${BlockService.SEARCH_VERRO_BUM_URL}&ts=${dateTime}`);
    return null;
  }

  public setBlockEmpty(data: Array<any>) {
    const translate = this.translate.translations[this.translate.currentLang];
    const keys = Object.keys(translate.BLOCK_TEMPS.BLOCKS);
    const caption = (data.length === 0 ? [] : data.map(d => d.caption));

    if (caption.length < keys.length) {
      _.each(keys, (d, i) => {
        if (caption.indexOf(d) === -1) {
          const _start = this.emptyData.start;
          const _end = this.emptyData.end;
          const date = this.setDateStartEndNow(_start, _end);
          const translate = this.translate.translations[this.translate.currentLang];
          const caption = translate.BLOCK_TEMPS.BLOCKS[TypeBlockLabel[d]]; // get mapping label by TypeBlock
          data.push({  key: TypeBlockLabel[d], caption: caption , data: [[new Date(date.start), 'EMPTY'], [new Date(date.end), 'EMPTY']] });
        }
      });
    }
    return data;
  }

  getRealTimeBlocks(noSystemBlocks: BlockVO[]) {
    return this.http.post(environment.api.blocktemps+'/cross-rt/', noSystemBlocks);
  }

  public refreshFormatBlock() {
    if(this.set_format_block) {
      const {username, date, data, breaks, dayOff, miseAPied, miseAPiedPeriod} = this.set_format_block;
      this.formatBlock(username, date, data, breaks, dayOff || null, miseAPied || null, miseAPiedPeriod || null)
    }
  }

  public formatBlock(username: string, date: string, data: any, breaks?, dayOff?, miseAPied?, miseAPiedPeriod?) {
    this.set_format_block = {username, date, data, breaks, dayOff, miseAPied, miseAPiedPeriod}
    this.block.dataset = [];
    this.currentDate = date;
    const arrayblock = [];
    let _data = [];
    let filter_shift_nghit = [];
    let filter_shift = [];
    this.tzService.setUser(username)
    data = _.sortBy(data, 'start');
    data = data.map((d, i) => {
      if(!BlockService.IN_HOLIDAYS(d)){
        d.start = this.tzService.GmtToLocale(d.start);
        d.end = this.tzService.GmtToLocale(d.end);
        d['tz'] = this.tzService.tz;
      }
      filter_shift_nghit.push(d)
      filter_shift.push(d)
      return d
    });
    const isSameDayFlag: boolean = data.filter(BlockService.PLANNED_NOT_HOLIDAY).filter((block) => {
      const day1 = moment(moment(date).add(1, 'days').format(DATE_DEFAULT_FORMAT + NIGHT_SHIFT_MIDNIGHT));
      const day2 = moment(moment(date).add(1, 'days').format(DATE_DEFAULT_FORMAT + NIGHT_SHIFT_END_TIME));
      const day3 = moment(moment(date).add(1, 'days').format(DATE_DEFAULT_FORMAT + NIGHT_SHIFT_MIDNIGHT_ALMOST));
      return moment(block.start).isBetween(day1, day2) ||
             moment(block.end).isBetween(day1, day2) ||
            (moment(block.start).isBetween(day1, day2) && moment(block.end).isSameOrAfter(day3))
    }).length > 0;
    this.isMidiToMidiDisplay = this.night_shift_midi_to_midi_display_test(data, date);
    this.block.isNight = this.checkNightShift(data.filter(BlockService.PLANNED_NOT_HOLIDAY), NIGH_SHIFT_START_TIME, NIGHT_SHIFT_MIDNIGHT_ALMOST, { fn: 'add', interval: 0 }).check
    && this.checkNightShift(data.filter(BlockService.PLANNED_NOT_HOLIDAY), NIGHT_SHIFT_MIDNIGHT, NIGHT_SHIFT_END_TIME, { fn: 'add', interval: 1 }, true).check
    console.log("isNight - 477 :",isSameDayFlag, date, data.filter(BlockService.PLANNED_NOT_HOLIDAY))

    const { _dayoffStartInterval, _dayoffEndInterval } = this.getIntervalOfCountry(date);
    this.emptyData = { start: _dayoffStartInterval, end: _dayoffEndInterval };
    if (username[0] === 'R') {
      const interval = this.setIntervalOfMaurice(filter_shift, data);
      data = interval.data;
      let tmp = interval.tmp;
      data = tmp;
    } else {
      data = this.getData(data, date);
    }
    if (data.filter(d=> d.type == "PLANNED" && (d.label && (d.label.toUpperCase() == "OFF" || d.label.toUpperCase().includes('HOLIDAY')))).length > 0){
      //data = this.deleteTimeEntryBlock(data);
      this.isDayOFF = true;
    }
    let originData = [];
    originData = (data === null ? [] : data);
    data = (data === null ? [] : this.PrepareJSON(data, username, date, breaks));
    data = this.onlyUniqueObj(data);

    const translate = this.translate.translations[this.translate.currentLang];
    if (data.length > 0) {

      _data = _.groupBy(data, 'name');
      if(!('PLANNED' in _data)) {
        _data['PLANNED'] = []
        console.log("ADD , PLANNED")
      }

      if(!('FULFILLED_SYSTEM' in _data)) {
        _data['FULFILLED_SYSTEM'] = []
        console.log("ADD , FULFILLED_SYSTEM")
      }

      if(!('FULFILLED_INCOHERENCE' in _data)) {
        _data['FULFILLED_INCOHERENCE'] = []
        console.log("ADD , FULFILLED_INCOHERENCE")
      }

      console.log("_data:", _data)
      _.each(_data, (i, n) => {
        n = n.toUpperCase(); // UpperCase Value Tags
        const caption = translate.BLOCK_TEMPS.BLOCKS[TypeBlockLabel[n]]; // get mapping label by TypeBlock

        const obj = { 'caption': caption , 'data': [] };
        _.each(i, (d, e) => {
          if (Object.keys(d).indexOf('motif') > -1) {
            if (d.motif.code === 'SEUILMOINS') {
              d.legend = 'INSERVICE';
              d.motif.label = '';
            }
            if (d.motif.code === 'SEUILPLUS') {
              d.legend = 'EMPTY';
            }
            if (['SEUILPLUS','SEUILMOINS'].includes(d.motif.code) && this.countryUser == "FR" && d.start && d.end && moment(d.end).diff(d.start, 'second') <= this.MIN_BLOCK_LENGTH_FR) {
              d.legend = 'INSERVICE';
              d.isSeuilFR = true;
              d.motif.label = '';
              d.motif.paied = true;
            }
          }
          let label = null;
          if (d.legend) {
            label = d.legend.toUpperCase();
          }
          if (d.legend === 'FULLFILLED_PAUSE') {
            d.start = moment(this.tzService.GmtToLocale(d.start)).toDate();
            d.end = moment(this.tzService.GmtToLocale(d.end)).toDate();
          }
          const start: any = [d.start, label, 100, , d.source];
          const end: any = [d.end, label, 100, , d.source];
          start['__data__'] = d;
          end['__data__'] = d;

          obj.data.push(start);
          obj.data.push(end);
        });
        arrayblock.push(obj);
      });
      console.log("arrayblock:", arrayblock)
      this.block.dataset = arrayblock;
    } else {
      this.block.dataset = [];
    }
    this.block.user = this.user;
    this.block.legend = Legends;
    this.block.temps_data = data;
    this.block.breaks = breaks;
    console.log('SortByKeys:', this.sortByArray(this.setBlockEmpty(this.block.dataset), translate.BLOCK_TEMPS.BLOCKS))
    this.block.dataset = this.sortByArray(this.setBlockEmpty(this.block.dataset), translate.BLOCK_TEMPS.BLOCKS);
    this.saveData[username] = {
      date: moment(date, DATE_DEFAULT_FORMAT).toDate(),
      data: (originData.length === 0 ? originData : originData.filter(d => d.type !== 'UNKNOWN')),
      breaks: this.block.breaks
    };
    this.refreshData[username] = this.block;
    const _date = this.setDateStartEndNow(_dayoffStartInterval, _dayoffEndInterval);

    // Todo change start or end of dayoff by interval specified
    if (dayOff) {
      this.block.dataset = this.block.dataset.map((d, i) => {
        if (d.key === TypeBlockLabel.PLANNED) {
          _date.start = moment(_date.start).format(DATE_DEFAULT_FORMAT + NIGHT_SHIFT_MIDNIGHT)
          _date.end = moment(_date.end).format(DATE_DEFAULT_FORMAT + NIGHT_SHIFT_MIDNIGHT_ALMOST)

          d.data = [[_date.start, 'DAYOFF'], [_date.end, 'DAYOFF']];
        }
        return d;
      });
    }
    if (miseAPied) {
      this.block.dataset = this.block.dataset.map((d, i) => {
        if (d.key === TypeBlockLabel.PLANNED) {
          d.data = [[this.DateToGMT(miseAPiedPeriod.utcStartTime), 'MISE_A_PIED'], [this.DateToGMT(miseAPiedPeriod.utcEndTime), 'MISE_A_PIED']];
        }
        return d;
      });
    }
    return this.block;
  }

  getIntervalOfCountry(date?) {
    //todo: this.currentDate is not syncronized
    // this.currentDate = date;
    let _dayoffStartInterval = (this.user.username[0] == 'R' ? moment(date ? date : this.currentDate).format(DATE_TIME_AT_7_0_0) : moment(date ? date : this.currentDate).format(DATE_DEFAULT_FORMAT + NIGHT_SHIFT_MIDNIGHT));
    let _dayoffEndInterval = (this.user.username[0] == 'R' ? moment(date ? date : this.currentDate).add(1, 'days').format(DATE_TIME_AT_7_0_0) : moment(date ? date : this.currentDate).format(DATE_DEFAULT_FORMAT + NIGHT_SHIFT_MIDNIGHT_ALMOST));
    if((this.isMidiToMidiDisplay || this.block.isNight) && this.user.username[0] != 'R'){
      _dayoffStartInterval = moment(date ? date : this.currentDate).format(DATE_DEFAULT_FORMAT + NIGHT_SHIFT_MIDI);
      _dayoffEndInterval = moment(date ? date : this.currentDate).add(1, 'days').format(DATE_DEFAULT_FORMAT + NIGHT_SHIFT_MIDI);
    }
    return { _dayoffStartInterval, _dayoffEndInterval };
  }

  private setIntervalOfMaurice(filter_shift, data: any) {
    this.block.hasDupplicateHoursDueToNightShift = false;
    this.block.hasDupplicateHoursDueToDayShift = false;
    const { _dayoffStartInterval, _dayoffEndInterval } = this.getIntervalOfCountry();
    let check = this.checkNightShift(filter_shift, MAURICE_TIME_LIMIT, MAURICE_TIME_LIMIT);
    data = check.data;
    let dates = check.dates;
    const date_is_after_current_date = _d => moment(moment(_d).format(DATE_DEFAULT_FORMAT)).isSameOrAfter(moment(this.currentDate));
    const date_is_before_current_date = _d => moment(moment(_d).format(DATE_DEFAULT_FORMAT)).isSameOrBefore(moment(this.currentDate).add(1, 'days'));
    dates = dates.filter(_d => date_is_after_current_date(_d) && date_is_before_current_date(_d));
    dates = dates.sort();
    let tmp = [];
        const dataFilterByDate = data
          .filter(e => {
            if (dates.includes(moment(e.start).format(DATE_DEFAULT_FORMAT)) || dates.includes(moment(e.end).format(DATE_DEFAULT_FORMAT))) {
              return e;
            }
          });
        dataFilterByDate.forEach((_d, i) => {
            if (moment(moment(_d.start).format(DATE_TIME_FORMAT)).isBefore(dates[0] + MAURICE_TIME_LIMIT) && moment(moment(_d.end).format(DATE_TIME_FORMAT)).isAfter(moment(dates[0] + MAURICE_TIME_LIMIT).format(DATE_TIME_FORMAT))) {
              _d.start = moment(dates[0] + MAURICE_TIME_LIMIT).format(DATE_TIME_FORMAT);
            }
            if (moment(moment(_d.end).format(DATE_TIME_FORMAT)).isAfter(moment(moment(dates[0] + MAURICE_TIME_LIMIT).add(1, 'days')).format(DATE_TIME_FORMAT))) {
              _d.end = moment(moment(dates[0] + MAURICE_TIME_LIMIT).add(1, 'days')).format(DATE_TIME_FORMAT);
            }
            /*
            if(BlockService.IN_HOLIDAYS(_d)){
              _d.start = _dayoffStartInterval;
              _d.end = _dayoffEndInterval;
            }*/
            if(moment(moment(_d.start).format(DATE_TIME_FORMAT)).isBefore(_dayoffStartInterval)){
              _d.start = _dayoffStartInterval;
            }
            if(moment(moment(_d.end).format(DATE_TIME_FORMAT)).isAfter(_dayoffEndInterval)){
              _d.end = _dayoffEndInterval;
            }
          this.specifyVacationAndDayOff('SET_INTERVAL', _d, _dayoffStartInterval, _dayoffEndInterval);
          tmp.push({..._d});
        });
    return { data, tmp };
  }

  /**
   *  justify start & end of vacation or dayoff
  * */
  private specifyVacationAndDayOff(s, _d, _dayoffStartInterval: string, _dayoffEndInterval: string) {
    if (BlockService.IN_HOLIDAYS(_d) || BlockService.IS_DAYOFF(_d)) {

      // Todo reset value start, end of 1/2 day of france
      const country = this.countryUser;

      console.log('IN_HOLD_DAYOFF', {
        source: s,
        _dayoffStartInterval,
        _dayoffEndInterval,
        data: JSON.stringify(_d),
        country,
        diffTime: moment(_d.end).diff(moment(_d.start), 'hours')
      })
      if (BlockService.IN_HOLIDAYS(_d) && country == "FR" && moment(_d.end).diff(moment(_d.start), 'hours') < 13) {
        _d.start = moment(_d.start).add(this.tzService.tz, 'hours').format(DATE_TIME_FORMAT);
        _d.end = moment(_d.end).add(this.tzService.tz, 'hours').format(DATE_TIME_FORMAT);
      } else {
        const date = moment(_d.start).format(DATE_DEFAULT_FORMAT);
        const isInStart = moment(_dayoffStartInterval).format(DATE_DEFAULT_FORMAT) == date;
        const isInEnd = moment(_dayoffEndInterval).format(DATE_DEFAULT_FORMAT) == date;
        if (isInStart) {
          _d.start = _dayoffStartInterval;
          _d.end = moment(date).format(DATE_TIME_AT_23_59_59);
        }
        if (isInEnd) {
          _d.start = moment(date).format(DATE_TIME_AT_0_0_0);
          _d.end = _dayoffEndInterval
        }
      }
    }
  }

  check_12_24 = data => this.checkNightShift(data, NIGHT_SHIFT_MIDI, NIGHT_SHIFT_MIDNIGHT_ALMOST, { fn: 'add', interval: 0 }).check;

  check_22_02 = data => this.checkNightShift(data, NIGH_SHIFT_START_TIME, NIGHT_SHIFT_MIDNIGHT, { fn: 'subtract', interval: 1 }).check
                     && this.checkNightShift(data, NIGHT_SHIFT_MIDNIGHT, NIGHT_SHIFT_END_TIME, { fn: 'add', interval: 0 }).check;

  night_shift_midi_to_midi_display_test = (data, date) => !this.check_12_24(data) && this.check_22_02(data) && this.dateIsAfterMinDateToApply(date);


  dateIsAfterMinDateToApply = (_d: string) => moment(moment(new Date(_d)).format(DATE_DEFAULT_FORMAT)).isAfter(new Date(MIN_DATE_TO_APPLY_NIGHT_SHIFT));

  checkBlockAreSpaceBetween = (list, unit,  maxHours) => (list && list.length == 1 && moment(list[0].end).diff(list[0].start, unit) < maxHours) || ( list && list.length == 2 && moment(list[0].start).diff(list[1].end, unit) > maxHours);

  dupplicateHoursDueToNightShift(data, date, _dayoffStartInterval, _dayoffEndInterval){
    return this.getReversedList(_.uniq(_.sortBy(data.filter(block =>
      BlockService.PLANNED_AND_REALISE(block) &&
      block.start &&
      block.end &&
      moment(block.end).diff(block.start, 'minutes') > 5, 'start')), x => x && x.id));
  }
  private getData(data: any, date: string) {
    //if(prompt('Set Traitement ?') == "0") return data;
    const night_shift_normal_display_test = (d: any) => this.block.isNight && this.dateIsAfterMinDateToApply(date) && moment(moment(d.start).format(DATE_TIME_FORMAT)).isBefore(moment(moment(this.currentDate).add(1, 'days')).format(DATE_DEFAULT_FORMAT) + NIGHT_SHIFT_MIDI_ALMOST);
    const night_shift_normal_display_filter_data = d => moment(moment(date).add(1, 'days').format(DATE_DEFAULT_FORMAT)).isSameOrBefore(moment(d.end)) || moment(date).isSameOrAfter(moment(d.start).format(DATE_DEFAULT_FORMAT)) || moment(date).isSameOrBefore(moment(d.end).format(DATE_DEFAULT_FORMAT));
    // Normal display
    const normal_display_filter_data = d => moment(moment(d.start).format(DATE_DEFAULT_FORMAT)).isSameOrBefore(date) &&  moment(moment(d.end).format(DATE_DEFAULT_FORMAT)).isSameOrAfter(date);
    const night_shift_midi_to_midi_display_data = this.checkNightShift(data, NIGHT_SHIFT_MIDI, NIGHT_SHIFT_MIDI_ALMOST).data.slice();
    //==============================================
    //========== Core Function =====================
    //==============================================
    let { _dayoffStartInterval, _dayoffEndInterval } = this.getIntervalOfCountry(date);
      const maxDateToCut = this.dupplicateHoursDueToDayNightSwitchProcess(data, date, _dayoffStartInterval, _dayoffEndInterval);
      if(this.block.isNight || this.isMidiToMidiDisplay){
        _dayoffEndInterval = maxDateToCut ? moment(maxDateToCut).format(DATE_TIME_FORMAT) : _dayoffEndInterval;
      }else{
        _dayoffStartInterval = maxDateToCut ? moment(maxDateToCut).format(DATE_TIME_FORMAT) : _dayoffStartInterval;
      }
      const resp = data.filter(d => {
        if (this.night_shift_midi_to_midi_display_test(data, date)) {
          return night_shift_midi_to_midi_display_data;
        }
        if (night_shift_normal_display_test(d)) {
          return night_shift_normal_display_filter_data(d);
        } else {
            return normal_display_filter_data(d);
        }
      }).map((_d, i) => {
        const clone = Object.assign({}, _d);
        if(moment(clone.start).isBefore(_dayoffStartInterval)){
          clone.start = _dayoffStartInterval;
        }
        if(moment(clone.end).isAfter(_dayoffEndInterval)){
          clone.end = _dayoffEndInterval;
        }
        if( moment(clone.start).isSameOrBefore(clone.end) ) {
          this.specifyVacationAndDayOff('GETDATA', clone, _dayoffStartInterval, _dayoffEndInterval);
        }

        /*
                if(BlockService.IN_HOLIDAYS(clone)){
                  this.LOG.info(`Holiday Display for Day ${date}`);
                  if(clone.user.username != '0130002940' ){
                    //@RG:|holiday test durration < 13hrs] of @PAY:[France] // ACTIVE IN PREPROD
                    const country = this.userService.getUser('countryCode');
                    if(!(country == "FR" && moment(clone.end).diff(moment(clone.start), 'hours') < 13)) {
                      //clone.start = _dayoffStartInterval;
                      //clone.end = _dayoffEndInterval;
                      clone.start = _dayoffStartInterval;
                      clone.end = _dayoffEndInterval;
                    }
                    /!*clone.start = _dayoffStartInterval;
                    clone.end = _dayoffEndInterval;*!/
                  }else {
                      /!*if(moment(clone.end).diff(moment(clone.start), 'hours') > 20){
                        clone.start = _dayoffStartInterval;
                        clone.end = _dayoffEndInterval;
                      }*!/
                  }
                }
        */


        // Todo apply Day off & congés [planned , 1/2 day]

        return clone;
      })
      .filter(block => moment(block.start).isBefore(moment(block.end)));

    console.log('CORE FUNCTION:', data, night_shift_midi_to_midi_display_data, resp)
    return resp
  }

  public getFirst2BlocksByFilter = (list, criterion: (b, c ?, d ?) => Boolean) => list && list.filter(criterion).slice(0, 2);

  public getReversedList = (list) => list && list.reverse();

  public getMinValueOfAtMostTwoParams = (min1, min2) => min1 && min2 ? Math.min.apply([], [min1, min2]) : (min1 ? min1 : null);

  public getMaxValueOfAtMostTwoParams = (max1, max2) => max1 && max2 ? Math.max.apply([], [max1, max2]) : (max1 ? max1 : max2);

  public getSeperatedBlocksFromList = (list, maxHours) => list.filter((current, index, original) =>(list && list.length > 1 && list[index +1 ] && current && moment(current.start).diff(list[index + 1].end, 'hours') > maxHours));

  public checkBlockIsIntervalIncluded = (b, _dayoffStartInterval, _dayoffEndInterval) => moment(b.start).isBetween(_dayoffStartInterval, _dayoffEndInterval) || moment(b.end).isBetween(_dayoffStartInterval, _dayoffEndInterval)

  public blockStartMapper = b => b && b.start;

  public dupplicateHoursDueToDayNightSwitchProcess(data, date, _dayoffStartInterval, _dayoffEndInterval){
    this.block.hasDupplicateHoursDueToNightShift = false;
    this.block.hasDupplicateHoursDueToDayShift = false;
    let dateToCut, maxPlanned, plannedMapper, maxRealise, realiseMapper, orderedBlocksDesc = this.dupplicateHoursDueToNightShift(data, date, _dayoffStartInterval, _dayoffEndInterval);
    const plannedBlocks = this.getSeperatedBlocksFromList(orderedBlocksDesc.filter(b => BlockService.PLANNED(b) && this.checkBlockIsIntervalIncluded(b, _dayoffStartInterval, _dayoffEndInterval)), 5);
    const realiseBlocks = this.getSeperatedBlocksFromList(orderedBlocksDesc.filter(b => !BlockService.PLANNED(b) && BlockService.PLANNED_AND_REALISE(b) && this.checkBlockIsIntervalIncluded(b, _dayoffStartInterval, _dayoffEndInterval)), 5);
    plannedMapper = plannedBlocks.map(this.blockStartMapper);
    realiseMapper =  realiseBlocks.map(this.blockStartMapper);
    maxPlanned = plannedBlocks && plannedBlocks.length > 0 ? Math.max.apply([], plannedMapper) : null;
    maxRealise = realiseBlocks && realiseBlocks.length > 0  ? Math.max.apply([], realiseMapper) : null;
    dateToCut = this.getMinValueOfAtMostTwoParams(maxPlanned, maxRealise);
    if(this.isMidiToMidiDisplay || this.block.isNight){
      this.block.hasDupplicateHoursDueToNightShift = dateToCut ? true : false;
      dateToCut ? this.LOG.info(`Blocks starting from ${moment(dateToCut).format(DATE_TIME_FORMAT)} have been removed from display due to unusual shifting from night to day `) : '';
    }else{
      dateToCut = this.getMinValueOfAtMostTwoParams(maxPlanned, maxRealise);
      this.block.hasDupplicateHoursDueToDayShift = dateToCut ? true : false;
      dateToCut ? this.LOG.info(`Blocks before ${moment(dateToCut).format(DATE_TIME_FORMAT)} have been deleted removed from display due to unusual shifting from night to day `) : '';
    }
    return dateToCut;
  }


  checkBlockInInterval(data, startDate, endDate): boolean {
    const isPlanned = d => {
      console.log('^^^ : ', d)
      return d.type === 'PLANNED' && d.label.includes('HOLIDAY')
    }
    const startDateIsBetween = data.filter(d => moment(d.start).isBetween(startDate, endDate) && isPlanned(d)).length > 0;
    const endDateIsBetween = data.filter(d => moment(d.end).isBetween(startDate, endDate) && isPlanned(d)).length > 0;
    return startDateIsBetween || endDateIsBetween;
  }

  public filterBlockInIntervall(data, startDate, endDate): boolean {
    return data.filter(d => moment(d.start).isBetween(startDate, endDate) || moment(d.end).isBetween(startDate, endDate));
  }

  public setDateStartEndNow(start, end) {
    const { _dayoffStartInterval, _dayoffEndInterval } = this.getIntervalOfCountry();
    return { start: _dayoffStartInterval, end: _dayoffEndInterval }
  }
  public DayOff(username, date, c, callback?) {
    date = moment(new Date(date)).format(DATE_DEFAULT_FORMAT);
    race(timer(TMP_MAX_WAIT_TIME_IN_MS).map(rs => TIMER_INDICATOR),
    this.http.get(`${environment.api.msplanning}/schedule/${username}?startDate=${date}&endDate=${date}&myref=true`))
      .subscribe(
        (data: any) => {
          if (data === TIMER_INDICATOR) {
            this.LOG.warn('MS Planning is not responding');
            callback();
          } else {
            this.LOG.info('MS Planning is OK');
            let dayOff = false;
            let miseAPied = false;
            let period;
            if (data.length > 0) {
              dayOff = Object.keys(data[0]).indexOf('dayOff') > -1;
              miseAPied = data[0] !== undefined &&
                data[0].absences !== undefined &&
                data[0]['absences'][0] !== undefined &&
                data[0]['absences'][0].absence !== undefined &&
                data[0]['absences'][0]['absence'].name === 'Mise à pied';
              if (miseAPied) {
                period = data[0]['projectedLayer'][0].period;
              }
            }
            c(dayOff, miseAPied, period);
          }
      },
      (err) => {
        if (callback) {
          this.LOG.warn(`Ms planning is OFF`);
          callback();
        }
      });
  }
  public DateToGMT(value) {
    const d = new Date();
    const diff = (d.getTimezoneOffset() / 60) * -1;
    let date = moment(value).add((-1 * diff), 'hours').toDate();
    if (this.user._username) {
      if (this.user._username[0].toLowerCase() == 'r') {
        date = moment(value).add(0, 'hours').toDate();
      }
    }
    return moment(date).format(DATE_TIME_FORMAT);
  }

  public GMTToLocale(value, action, c?) {
    /*    const d    = new Date();
        const diff = (d.getTimezoneOffset() / 60)
        let  date = moment(value).add(action * diff, 'hours').toDate();
        this.TimezoneGMT = action * diff;
        if(this.user._username[0].toLowerCase() == 'r') {
          date = moment(value).add(0, 'hours').toDate();
          this.TimezoneGMT = -8;
        }
        if(typeof c != 'undefined') c(date, diff)*/
    return value;
  }

  public validationBlockByUser(data: any, callback?) {
    this.http.post(environment.api.blocktemps + '/block/validate', data)
      .subscribe((d: any) => { callback(); },
        error => { this.session.redirectBadRequest(error); });
  }

  public openFicheByUser(data: any, callback?, errorCallback?) {
    this.http.post(environment.api.blocktemps + '/support/open', data)
      .subscribe((d: any) => { callback(); },
        error => { errorCallback(error); });
  }

  public unlockFicheByUser(data: any, callback?, errorCallback?) {
    this.http.post(environment.api.blocktemps + '/requestUnlocking/open', data)
      .subscribe((d: any) => { callback(); },
        error => { errorCallback(error); });
  }

  public removeSeuil(e) {
    const s = (Object.keys(e).indexOf('motif') > -1 ? ['SEUILPLUS'].indexOf(e.motif.code) > -1 : false);
    const roles = environment.block.SEUIL.roles;
    const d = roles.filter(e => Object.keys(this.userService.getPermission()).indexOf(e) > -1);
    return s && d.length > 0 && environment.block.SEUIL.status;
  }

  public getReclamation(user) {
    return this.http.get(environment.api.blocktemps + '/reclamation?username=' + user);
  }
  public sendReclamation(data, c?) {
    // console.log(data)
    this.http.post(environment.api.blocktemps + '/reclamation/subreclamation', data).subscribe(item => {
      c(item)
    },
      err => {
        // console.log(err)
      });
  }

  putBreaksInco(data: any) {
    return this.http.post(environment.api.blocktemps + '/breakTemp', data)
  }
  checkBreaksInco(data: any) {
    return this.http.post(environment.api.blocktemps + '/breakTemp/check', data)
  }

  checkNightShift(data, timeStart, timeEnd, operation?, sameDayFlag?) {
    timeStart = timeStart.startsWith(' ') ? timeStart : ' ' + timeStart;
    timeEnd = timeEnd.startsWith(' ') ? timeEnd : ' ' + timeEnd;

    let night_data = [];
    let check_night_data = [];
    let dateBefore_1 = moment(this.currentDate).format(DATE_DEFAULT_FORMAT);
    let dateAfter_1 = !operation ? moment(this.currentDate).add(1, 'days').format(DATE_DEFAULT_FORMAT) : moment(this.currentDate).format(DATE_DEFAULT_FORMAT);
    if (typeof operation !== 'undefined') {
      let { fn, interval } = operation;
      if (fn == "add")
        dateAfter_1 = moment(this.currentDate)[fn](interval, 'days').format(DATE_DEFAULT_FORMAT)
      else
        dateBefore_1 = moment(this.currentDate)[fn](interval, 'days').format(DATE_DEFAULT_FORMAT)
    }

    if(sameDayFlag){
      dateBefore_1 = moment(this.currentDate).add(1, 'days').format(DATE_DEFAULT_FORMAT);
      dateAfter_1 =moment(this.currentDate).add(1, 'days').format(DATE_DEFAULT_FORMAT)
    }

    data = data.filter((d, i) => {
      if (
        [moment(d.start).format(DATE_DEFAULT_FORMAT), moment(d.end).format(DATE_DEFAULT_FORMAT)].indexOf(dateBefore_1) > -1 ||
        [moment(d.start).format(DATE_DEFAULT_FORMAT), moment(d.end).format(DATE_DEFAULT_FORMAT)].indexOf(dateAfter_1) > -1
      ) {
        return d
      }
    });
    dateBefore_1 += timeStart; //NIGH_SHIFT_START_TIME;
    dateAfter_1 += timeEnd; //NIGHT_SHIFT_END_TIME;
    data.forEach((d, i) => {

      let start = moment(d.start).format(DATE_TIME_FORMAT)
      let end = moment(d.end).format(DATE_TIME_FORMAT)

      let condition1 = moment(start).isBetween(dateBefore_1, dateAfter_1);
      let condition2 = moment(end).isBetween(dateBefore_1, dateAfter_1);
      let condition3 = moment(dateBefore_1).isBetween(start, end);
      let condition4 = moment(dateAfter_1).isBetween(start, end);
      // /*console.log('------------------------------------------------------');
      // if(condition3){
      //   console.log('Condition3', start, end, dateBefore_1);
      // }
      // if(condition4){
      //   console.log('Condition4', start, end, dateAfter_1);
      // }
      // console.log('------------------------------------------------------');*/
      if (condition1 || condition2 || condition3 || condition4) {
        const key = moment(d).format(DATE_MOUNTH_DAY_FORMAT)
        //if(typeof night_data[key] == 'undefined') night_data[key] = [];
        night_data.push(d);
        check_night_data.push(moment(d.start).format(DATE_DEFAULT_FORMAT));
        check_night_data.push(moment(d.end).format(DATE_DEFAULT_FORMAT));

      }
    })

    const check_night_data_bis = night_data.filter(BlockService.PLANNED_NOT_HOLIDAY).slice();
    const result = { interval: [dateBefore_1, dateAfter_1], check: _.uniq(check_night_data_bis).length > 0, data: night_data, dates: _.uniq(check_night_data), _originData: data };

    // console.warn('night_data', night_data, result.dates)
    /*if(result.dates.length == 1) {
      result.data = [];
    }*/
    return result;
  }

  declarativeInjection(blocks, ignoreBreak: boolean) {
    return this.http.post(environment.api.blocktemps + `/tma/declarativeInjection?shiftDate=${this.currentDate}&matricule=${this.user.username}&ignoreBreak=${ignoreBreak}`, blocks);
  }

  onlyUniqueObj(array) {
    const filteredArr = array.reduce((acc, current) => {
      const x = acc.find(item => item.id === current.id && item.start == current.start && item.end == current.end);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    return filteredArr;
  }

  checkLockedShift(user: any) {
    const date = localStorage.getItem('date_' + user.username);
    return this.http.get(`${environment.api.blocktemps}/block/lockStateDetails/?username=${user.username}&date=${date}`)
  }
  /**
   * Update Status TAD By IDS block
   * */
  updateTad(status: boolean, ids: Array<string>): Observable<any> {
    return this.http.post(`${environment.api.blocktemps}/block/tad/updateStatus?tad=${status}`, ids);
  }

  getPrioritizedSources(username: any, date: any) {
    return this.http.get(`${environment.api.blocktemps}/block/mutualisation/?username=${username}&date=${date}`);
  }

  updatePrioritizedSources(username: any, date: any, sources: any) {
    return this.http.post(`${environment.api.blocktemps}/block/mutualisation/?username=${username}&date=${date}&sources=${sources}`, {});
  }

  getDateFromHeader(key: string): Promise<any> {
    return new Promise<any>((r, j) => {
      const xhr: any = new XMLHttpRequest();
      const method = 'head';
      const url = window.location.origin
      xhr.open(method,url,true);
      xhr.send(null);

      xhr.onreadystatechange = function()
      {
        if (xhr.readyState === 4)
        {
          r(xhr.getResponseHeader(key))
        }
      };
    })
  }
  // check import & cross is ok by date
  availableBlock(date, matricule) {
    return this.http.get(environment.api.blocktemps + '/block/availableByUser', {
      params: {
        date,
        matricule
      }
    })
  }

  getUOByUserName(userName: string): any {
    return new Promise((r, j) => {
      this.http.get(`${environment.api.blocktemps}/block/mutualisation/site`, {
        params: {
          registrationNumber: userName
        }
      }).subscribe((data) => r({response: data, status: true, message: null}),
          err => r({response: [], status: false, message: err}))
    })
  }

  getMutualisation(username: string, date: string): any {
    return new Promise((r, j) => {
      this.http.get(`${environment.api.blocktemps}/block/mutualisation/mutualisationUo`, {
        params: {
          username, date
        }
      }).subscribe((data) => r({response: data, status: true, message: null}),
          err => r({response: [], status: false, message: err}))
    })
  }

  private sortByArray(blocs: Array<any>, blockKeys: any) {
    return Object.values(blockKeys).map((v) => {
      return blocs.find(b => b.caption == v);
    })
  }

  saveBlocksMutualisation(data: any): any {
    return this.http.post(`${environment.api.blocktemps}/block/mutualisation/mutualisationUo`, data);
  }


  /**
   *
   * FormatBlockV2 Without deps to this fields class
   *
   * */
  public formatBlockV2(username: string, date: string, data: any, breaks?, dayOff?, miseAPied?, miseAPiedPeriod?) {
    const translate = this.translate.translations[this.translate.currentLang];
    const block: any = {
      dataset: [],
      currentDate: date,
      isMidiToMidiDisplay: null,
      isNight: false,
      breaks: [],
      temps_data: [],
      legend: {},
      user: null,
      view: 'ONLY_DATA',
      Display: {
        row: ['Réalisé validé'],
        breaks: true,
        header: true,
        paginator: true,
        buttons: {
          valider: true,
          claim: false
        },
        styles: {
          margin: {top: 70, right: 40, bottom: 20, left: 100},
          height: '70px',
          width: 940
        },
        dialog: true
      }
    };
    const arrayblock = [];
    let _data = [];
    let filter_shift_nghit = [];
    let filter_shift = [];
    data = _.sortBy(data, 'start');
    data = data.map((d, i) => {
      if (!BlockService.IN_HOLIDAYS(d)) {
        d.start = moment(d.start).toDate();
        d.end = moment(d.end).toDate();
        d['tz'] = this.tzService.tz;
      }
      filter_shift_nghit.push(d)
      filter_shift.push(d)
      return d
    });
    block.isMidiToMidiDisplay = this.night_shift_midi_to_midi_display_test(data, date);
    block.isNight = this.checkNightShift(data.filter(BlockService.PLANNED_NOT_HOLIDAY), NIGH_SHIFT_START_TIME, NIGHT_SHIFT_MIDNIGHT_ALMOST, {
        fn: 'add',
        interval: 0
      }).check
      && this.checkNightShift(data.filter(BlockService.PLANNED_NOT_HOLIDAY), NIGHT_SHIFT_MIDNIGHT, NIGHT_SHIFT_END_TIME, {
        fn: 'add',
        interval: 1
      }, true).check

    const {_dayoffStartInterval, _dayoffEndInterval} = this.getIntervalOfCountry(date);
    this.emptyData = {start: _dayoffStartInterval, end: _dayoffEndInterval};
    if (username[0] === 'R') {
      const interval = this.setIntervalOfMaurice(filter_shift, data);
      data = interval.data;
      let tmp = interval.tmp;
      data = tmp;
    } else {
      data = this.getData(data, date);
    }
    if (data.filter(d=> d.type == "PLANNED" && (d.label && (d.label.toUpperCase() == "OFF" || d.label.toUpperCase().includes('HOLIDAY')))).length > 0){
      //data = this.deleteTimeEntryBlock(data);
      this.isDayOFF = true;
    }
    let originData = [];
    originData = (data === null ? [] : data);
    data = (data === null ? [] : this.PrepareJSON(data, username, date, breaks));
    data = this.onlyUniqueObj(data);

    if (data.length > 0) {

      _data = _.groupBy(data, 'name');
      _.each(_data, (i, n) => {
        n = n.toUpperCase(); // UpperCase Value Tags
        const obj = {'caption': translate.BLOCK_TEMPS.BLOCKS[TypeBlockLabel[n]], 'data': []};
        _.each(i, (d, e) => {
          if (Object.keys(d).includes('motif')) {
            if (d.motif.code === 'SEUILMOINS') {
              d.legend = 'INSERVICE';
              d.motif.label = '';
              d.motif.paied = true;
            }
            if (d.motif.code === 'SEUILPLUS') {
              d.legend = 'EMPTY';
              d.motif.paied = true;
            }
            if (['SEUILPLUS','SEUILMOINS'].includes(d.motif.code) && this.countryUser == "FR" && d.start && d.end && moment(d.end).diff(d.start, 'second') <= this.MIN_BLOCK_LENGTH_FR) {
              d.legend = 'INSERVICE';
              d.isSeuilFR = true;
              d.motif.label = '';
              d.motif.paied = true;
            }
          }
          let label = null;
          if (d.legend) {
            label = d.legend.toUpperCase();
          }
          if (d.legend === 'FULLFILLED_PAUSE') {
            d.start = moment(this.tzService.GmtToLocale(d.start)).toDate();
            d.end = moment(this.tzService.GmtToLocale(d.end)).toDate();
          }
          obj.data.push([d.start, label, 100, , d.source, d.motif, d.id]);
          obj.data.push([d.end, label, 100, , d.source, d.motif, d.id]);
        });
        arrayblock.push(obj);
      });
      block.dataset = arrayblock;
    } else {
      block.dataset = [];
    }
    block.user = this.user;
    block.legend = Legends;
    block.temps_data = data;
    block.breaks = breaks;
    block.dataset = _.sortBy(this.setBlockEmpty(block.dataset), 'caption');
    this.saveData[username] = {
      date: moment(date, DATE_DEFAULT_FORMAT).toDate(),
      data: (originData.length === 0 ? originData : originData.filter(d => d.type !== 'UNKNOWN')),
      breaks: block.breaks
    };
    this.refreshData[username] = block;
    const _date = this.setDateStartEndNow(_dayoffStartInterval, _dayoffEndInterval);
    if (dayOff) {
      console.log(block.dataset)
      block.dataset = block.dataset.map((d, i) => {
        if (d.caption === 'Prévu') {
          alert(1)
          _date.start = moment(_date.start).format(DATE_DEFAULT_FORMAT + NIGHT_SHIFT_MIDNIGHT)
          _date.end = moment(_date.end).format(DATE_DEFAULT_FORMAT + NIGHT_SHIFT_MIDNIGHT_ALMOST)

          d.data = [[_date.start, 'DAYOFF'], [_date.end, 'DAYOFF']];
        }
        return d;
      });
    }
    if (miseAPied) {
      block.dataset = block.dataset.map((d, i) => {
        if (d.caption === 'Prévu') {
          d.data = [[this.DateToGMT(miseAPiedPeriod.utcStartTime), 'MISE_A_PIED'], [this.DateToGMT(miseAPiedPeriod.utcEndTime), 'MISE_A_PIED']];
        }
        return d;
      });
    }
    return block;
  }

  async checkVerroOfUo(ficheDate) {
    const exceptionUo = environment.verroFiche.exceptionUo;
    let checkDate = false;
    const details = JSON.parse(localStorage.getItem("DETAILS") || '{"uo": null}');

    Object.keys(exceptionUo).forEach((uo) => {
      const date = exceptionUo[uo];
       checkDate = String(details.uo).toLowerCase().includes(uo) &&  moment(date).isSameOrAfter(ficheDate);
    })
    return checkDate;
  }

  croisement(data: CroisementVO, callback): Promise<any> {
    const {start, end, matricules} = data;
    return  new Promise((resolve, reject) => {
      this.http.post(`${environment.api.myshiftUrl}/tma/cross?start=${start}&end=${end}&matricules=${matricules}`, {}).subscribe((vo: any) => {
        resolve(vo);
      }, error => {
        callback();
        resolve(error);
      }, () => {
        callback();
      })
    })
  }
  deVerro(data: VerroVO, callback): Promise<any> {
    const {durationExp, day, matricules} = data;
    return  new Promise((resolve, reject) => {
      this.http.post(`${environment.api.myshiftUrl}/tma/verro?day=${day}&durationExp=${durationExp}&matricules=${matricules}`, {}).subscribe((vo: any) => {
        resolve(vo);
      }, error => {
        callback();
        resolve(error);
      }, () => {
        callback();
      })
    })
  }
  getStandBy(registrationNumber: string, startDate: string): any {
    return new Promise((r, j) => {
      this.http.get(`${environment.api.myshiftUrl}/standby`, {
        params: {
          registrationNumber, startDate
        }
      }).subscribe((data) => r(data),
          err =>{})
    })
  }

  getRoles(matricule: string):any {
    return this.http.get(`${environment.api.myshiftUrl}/otherRole/getByUsername?username=${matricule}`);
  }

  loadBlockRealizedByDateMatricule(injectionsDateUsername:any[]) {
    return this.http.post(`${environment.api.myshiftUrl}/injection/v2/checkBlocksList`, injectionsDateUsername)
  }

  private downloadFile(guideType: string) {
    console.log("file ",guideType);
    const headers = new HttpHeaders();
    headers.append('Accept', 'application/pdf');
    return this.http.get("./download/"+guideType, { responseType: 'blob', headers: headers });

  }

  private deleteTimeEntryBlock(data: any) {
    return data.filter(d => d.justification && !JUSTIFICATION_TIME_INSERT.includes(d.justification));
  }

  filterData(mapValues: { entry: any; key: string }[],data) {
    let res : any[] = [];
    mapValues.forEach(value => {
      let filter =  (res.length>0?res:data).filter((d: any) => {
        const dateFicheRange = [DATE_DEBUT_FICHE_LABEL, DATE_FIN_FICHE_LABEL];
        const dateDemandeRange = [DATE_DEBUT_DEMANDE_LABEL, DATE_FIN_DEMANDE_LABEL];
        const hasDateFicheRange = this.dateRangeFilter(dateFicheRange, mapValues);
        const hasDateDemandeRange = this.dateRangeFilter(dateDemandeRange, mapValues);
        if(hasDateFicheRange){
          const dateDebutfiche = mapValues.find(val => val.key == DATE_DEBUT_FICHE_LABEL)?mapValues.find(val => val.key == DATE_DEBUT_FICHE_LABEL).entry:null;
          const dateFinFiche = mapValues.find(val => val.key == DATE_FIN_FICHE_LABEL)?mapValues.find(val => val.key == DATE_FIN_FICHE_LABEL).entry:null;
          // console.log(1, dateDebutfiche, dateFinFiche)
          return this.filterDateRangePredicate(dateDebutfiche, dateFinFiche, d[DATE_FICHE_LABEL]);
          }
          if(hasDateDemandeRange){
            const dateDebutDemande= mapValues.find(val => val.key == DATE_DEBUT_DEMANDE_LABEL)?mapValues.find(val => val.key == DATE_DEBUT_DEMANDE_LABEL).entry:null;
            const dateFinDemande= mapValues.find(val => val.key == DATE_FIN_DEMANDE_LABEL)?mapValues.find(val => val.key == DATE_FIN_DEMANDE_LABEL).entry:null;
            // console.log(2, dateDebutDemande, dateFinDemande)
            return this.filterDateRangePredicate(dateDebutDemande, dateFinDemande, d[DATE_DEMANDE_LABEL]);
          }
          if(!hasDateFicheRange && !hasDateDemandeRange){
            const dateFichePredicate = this.filterDatePredicate(DATE_DEBUT_FICHE_LABEL, DATE_FIN_FICHE_LABEL, value, d[DATE_FICHE_LABEL]);
            const dateDemandePredicate = this.filterDatePredicate(DATE_DEBUT_DEMANDE_LABEL, DATE_FIN_DEMANDE_LABEL, value, d[DATE_DEMANDE_LABEL]);
            if(dateFichePredicate) return dateFichePredicate;
            if(dateDemandePredicate) return dateDemandePredicate;
          }

          if (value.key == "agent" && d.agent) {
            if (!d.agentFirstName || !d.agentLastName)
              return d[value.key].toLowerCase().indexOf(value.entry.toLowerCase()) != -1;

            return d[value.key].toLowerCase().indexOf(value.entry.toLowerCase()) != -1 ||
              (d.agentFirstName && d.agentFirstName.toLowerCase().indexOf(value.entry.toLowerCase()) != -1) ||
              (d.agentLastName && d.agentLastName.toLowerCase().indexOf(value.entry.toLowerCase()) != -1) ||
              (d.agentFirstName.toLowerCase() + " "+d.agentLastName.toLowerCase()).indexOf(value.entry.toLowerCase()) != -1;

          }
          if (value.key == "demandeur" && d.demandeur) {
            if (!d.demandeurFirstName || !d.demandeurLastName)
              return d[value.key].toLowerCase().indexOf(value.entry.toLowerCase()) != -1;

            return d[value.key].toLowerCase().indexOf(value.entry.toLowerCase()) != -1 ||
              (d.demandeurFirstName && d.demandeurFirstName.toLowerCase().indexOf(value.entry.toLowerCase()) != -1) ||
              (d.demandeurLastName && d.demandeurLastName.toLowerCase().indexOf(value.entry.toLowerCase()) != -1) ||
              (d.demandeurFirstName.toLowerCase() + " "+d.demandeurLastName.toLowerCase()).indexOf(value.entry.toLowerCase()) != -1;

          }
          if (value.key == "status"){
            let filter = [];
            value.entry.forEach(s=> {
              if(s.toUpperCase() == "REJECTED_UNLOCKING")
                filter.push("REJECTED")
              else filter.push(s)});
            if (filter.length == 1)
              return d[value.key].toLowerCase().indexOf(filter[0].toLowerCase()) != -1 ||
                d.status.toLowerCase().indexOf(filter[0].toLowerCase()) != -1;

            if (filter.length == 2)
              return d[value.key].toLowerCase().indexOf(filter[0].toLowerCase()) != -1 ||
                d.status.toLowerCase().indexOf(filter[0].toLowerCase()) != -1 ||
                d[value.key].toLowerCase().indexOf(filter[1].toLowerCase()) != -1 ||
                d.status.toLowerCase().indexOf(filter[1].toLowerCase()) != -1;
          }

          if (!d[value.key]) return;
          return d[value.key].toLowerCase().indexOf(value.entry.toLowerCase()) != -1
      })
      res = [...filter];
    });

    return res;
  }
  dateRangeFilter = (dateRange, mapValues) =>{
    return _.intersection(mapValues.map(val => val.key),  dateRange).length == 1 || _.intersection(mapValues.map(val => val.key),  dateRange).length == 2;
  }
  filterDateRangePredicate = (dateDebut, dateFin, date) => {
    if (dateDebut && dateFin)
      return moment(moment(date).format(DATE_DEFAULT_FORMAT)).isSameOrAfter(moment(dateDebut).format(DATE_DEFAULT_FORMAT)) &&
        moment(moment(date).format(DATE_DEFAULT_FORMAT)).isSameOrBefore(moment(dateFin).format(DATE_DEFAULT_FORMAT));
    if (dateDebut)
      return moment(moment(date).format(DATE_DEFAULT_FORMAT)).isSameOrAfter(moment(dateDebut).format(DATE_DEFAULT_FORMAT));

    if (dateFin)
      return moment(moment(date).format(DATE_DEFAULT_FORMAT)).isSameOrBefore(moment(dateFin).format(DATE_DEFAULT_FORMAT));

    return;


  }

  filterDatePredicate = (dateDebut, dateFin, value, date) => {
    if(value.key == dateDebut || value.key == dateFin){
      if(value.key == dateDebut ){
        this.LOG.info(`filter date : ${moment(value.entry).format(DATE_DEFAULT_FORMAT)} actual date : ${date} result : ${moment(moment(date).format(DATE_DEFAULT_FORMAT)).isSameOrBefore(date)}`);
        return moment(moment(value.entry).format(DATE_DEFAULT_FORMAT)).isSameOrBefore(moment(date).format(DATE_DEFAULT_FORMAT));
      }

      if(value.key == dateFin){
        this.LOG.info(`filter date : ${moment(value.entry).format(DATE_DEFAULT_FORMAT)} actual date : ${date} result : ${moment(moment(date).format(DATE_DEFAULT_FORMAT)).isSameOrAfter(date)}`);
        return moment(moment(value.entry).format(DATE_DEFAULT_FORMAT)).isSameOrAfter(moment(date).format(DATE_DEFAULT_FORMAT));
      }
    }
  }

  getCommentFiche(dateShift: any, user: any, typeComment: string):Observable<any[]> {
    return this.http.get<any[]>(environment.api.blocktemps + '/comments/by-username-date-type?username='+user+'&date='+dateShift+'&type='+typeComment);
  }
  saveComments(comment: CommentFiche) {
    return this.http.post(environment.api.blocktemps + '/comments/save?username='+comment.username,comment);
  }

  loadUsers() {
    return this.http.get<any[]>(environment.api.blocktemps + '/user-admin/get-admins');
  }

  deleteUser(id) {
    return this.http.delete<any>(environment.api.blocktemps + '/user-admin/delete/'+id);

  }

  addNewUser(matricule: any) {
    return this.http.post<any>(environment.api.blocktemps + '/user-admin/save?username='+matricule,matricule);
  }

  checkUserShowComment(currentUser: any, idComment: any) {
    ///comments/is-readed?idComment=120&username=047791
    return this.http.get<any>(environment.api.blocktemps + `/comments/is-readed?idComment=${idComment}&username=${currentUser}`);
  }

  userShowComment(currentUser: any, idComment: any) {
    return this.http.post<any>(environment.api.blocktemps + `/comments/mark-as-readed?idComment=${idComment}&username=${currentUser}`,true);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/BlockService.ts